import React, { Component } from "react";
import Axios from "axios";
import Constant from "../Constant";
import "../../css/style.css";

import $ from "jquery";
import { getAccessToken } from "../../hooks/AccessToken";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";

class DataManagement extends Component {
  state = {
    ERROR: true,
    DataList: [],
    allDataList: [], // Store all data for client-side filtering
    selectValue: "",
    length: "",
    pageNo: "",
    defaultPageNo: 1,
    searchKey: "",
    sortByAttribute: 1,
    searchValue: "", // For search input
    togglingApprovalIds: {},
    forYouMap: {},
    togglingForYouIds: {},
    selectedDescription: null,
    showHtml: true,
  };

  debounceTimer = null; // For debounced search
  _approvalToggleLocks = new Set();

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  openDescriptionPopup = (description) => {
    this.setState({ selectedDescription: description, showHtml: true });
  };

  closeDescriptionPopup = () => {
    this.setState({ selectedDescription: null });
  };

  toggleHtml = () => {
    this.setState((prevState) => ({ showHtml: !prevState.showHtml }));
  };

  handleSearchValueChange = (e) => {
    this.setState({ searchValue: e.target.value }, () => {
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.handleSearch();
      }, 300);
    });
  };

  handleSearch = () => {
    const { allDataList, searchValue } = this.state;
    let filtered = allDataList;
    if (searchValue) {
      const val = searchValue.toLowerCase();
      filtered = allDataList.filter(item =>
        (item.name && item.name.toLowerCase().includes(val)) ||
        (item._id && item._id.toLowerCase().includes(val))
      );
    }
    this.setState({ DataList: filtered });
  };

  //----------------------------------Toggle approved / rejected (single click)-----------------\\

  /** 0 = legacy pending → approve (1); 1 → reject (2); 2 → approve (1) */
  toggleApprovalStatus = async (id, currentStatus) => {
    const idStr = String(id);
    if (this._approvalToggleLocks.has(idStr)) return;
    this._approvalToggleLocks.add(idStr);

    const c = Number(currentStatus);
    const previousStatus = Number.isNaN(c) ? 0 : c;
    const nextStatus =
      previousStatus === 2 ? 1 : previousStatus === 0 ? 1 : 2;

    const patchList = (list, statusVal) =>
      list.map((el) =>
        String(el._id) === idStr ? { ...el, status: statusVal } : el
      );

    this.setState((prev) => ({
      togglingApprovalIds: { ...prev.togglingApprovalIds, [idStr]: true },
      allDataList: patchList(prev.allDataList, nextStatus),
      DataList: patchList(prev.DataList, nextStatus),
    }));

    const metaData = {
      id,
      status: nextStatus,
      standard: 0,
      type: 1,
      reason: "",
    };

    const clearTogglingUi = () => {
      this.setState((prev) => {
        const nextMap = { ...prev.togglingApprovalIds };
        delete nextMap[idStr];
        return { togglingApprovalIds: nextMap };
      });
    };

    const revertOptimistic = () => {
      this.setState((prev) => ({
        allDataList: patchList(prev.allDataList, previousStatus),
        DataList: patchList(prev.DataList, previousStatus),
        togglingApprovalIds: (() => {
          const nextMap = { ...prev.togglingApprovalIds };
          delete nextMap[idStr];
          return nextMap;
        })(),
      }));
    };

    try {
      const token = getAccessToken();
      const response = await Axios.patch(
        Constant.apiBasePath + "poem/changeStatus/" + id,
        metaData,
        { headers: { token } }
      );
      const { data } = response;
      if (data.status === Constant.statusSuccess) {
        if (previousStatus === 0 && nextStatus === 1) {
          toast.success("Poem approved (was pending)");
        } else if (nextStatus === 1) {
          toast.success("Poem approved");
        } else {
          toast.success("Poem rejected");
        }
        clearTogglingUi();
      } else {
        revertOptimistic();
        toast.error(data.message || "Could not update status");
      }
    } catch (err) {
      console.log(err);
      revertOptimistic();
      const msg =
        (err.response && err.response.data && err.response.data.message) ||
        err.message ||
        "Could not update status";
      toast.error(msg);
    } finally {
      this._approvalToggleLocks.delete(idStr);
    }
  };

  //------------------------------------Integrate API for remove banner-------------------------------//

  delete = async (event) => {
    try {
      let token = getAccessToken();
      const response = await Axios.delete(
        Constant.apiBasePath + "poem/" + event,
        { headers: { token: token } }
      );
      let data = response.data;
      if (data.status === Constant.statusSuccess) {
        $("#gen-message").text(data.message);
        $("#gen-message").css("color", "green");
        window.scrollTo(0, 0);
        this.handleSubmit(this.state.defaultPageNo);
        setTimeout(function () {
          $("#gen-message").text("");
        }, 3000);
      } else {
        $("#gen-message").text(data.message);
        $("#gen-message").css("color", "red");
        setTimeout(function () {
          $("#gen-message").text("");
        }, 3000);
      }
    } catch (err) {
      console.log(err);
    }
  };

  update = async (event) => {
    try {
      this.props.history.push("/update-poem/" + event);
    } catch (err) {
      console.log(err);
    }
  };

  fetchForYouMembership = async (rows) => {
    try {
      const ids = (rows || []).map((el) => String(el._id)).filter(Boolean);
      if (ids.length === 0) {
        this.setState({ forYouMap: {} });
        return;
      }

      const token = getAccessToken();
      const response = await Axios.post(
        Constant.apiBasePath + "for-you/membership",
        {
          contentType: "poem",
          contentIds: ids,
        },
        { headers: { token } }
      );

      const inForYou = (response.data && response.data.inForYou) || [];
      const map = {};
      inForYou.forEach((id) => {
        map[String(id)] = true;
      });
      this.setState({ forYouMap: map });
    } catch (err) {
      console.log(err);
    }
  };

  toggleForYou = async (item) => {
    const id = String(item._id);
    const isInForYou = !!this.state.forYouMap[id];

    this.setState((prev) => ({
      togglingForYouIds: { ...prev.togglingForYouIds, [id]: true },
    }));

    try {
      const token = getAccessToken();
      if (isInForYou) {
        const response = await Axios.delete(
          Constant.apiBasePath + "poem/for-you/" + id,
          { headers: { token } }
        );
        if (response.data.status === Constant.statusSuccess) {
          this.setState((prev) => ({
            forYouMap: { ...prev.forYouMap, [id]: false },
          }));
          toast.success("Removed from For You");
        } else {
          toast.error(response.data.message || "Could not remove from For You");
        }
      } else {
        const response = await Axios.post(
          Constant.apiBasePath + "poem/for-you",
          { contentId: id },
          { headers: { token } }
        );
        if (response.data.status === Constant.statusSuccess) {
          this.setState((prev) => ({
            forYouMap: { ...prev.forYouMap, [id]: true },
          }));
          toast.success("Added to For You");
        } else {
          toast.error(response.data.message || "Could not add to For You");
        }
      }
    } catch (err) {
      const msg =
        (err.response && err.response.data && err.response.data.message) ||
        err.message ||
        "Could not update For You";
      toast.error(msg);
    } finally {
      this.setState((prev) => {
        const next = { ...prev.togglingForYouIds };
        delete next[id];
        return { togglingForYouIds: next };
      });
    }
  };

  //----------------------------------Integrate show banner API----------------------------------\\

  handleSubmit = async (event, sort) => {
    try {
      let token = getAccessToken();
      let selectValue = $("#selectValue").val();
      let sortByAttribute = this.state.sortByAttribute;
      if (sort) {
        this.setState({ sortByAttribute: sort });
        sortByAttribute = sort;
      }
      // Only use selectValue for status filtering, not for search
      const response = await Axios.post(
        Constant.apiBasePath + "poem/get-all",
        {
          key: selectValue,
          pageNo: event,
          searchKey: "",
          sortByAttribute: sortByAttribute,
        },
        { headers: { token: token } }
      );
      const { data, length, pageNo } = response.data;
      this.setState({
        DataList: data,
        allDataList: data, // Store all data for client-side filtering
        length: length,
        pageNo: pageNo,
        defaultPageNo: event,
        selectValue: "",
        searchKey: "",
        ERROR: false,
      });
      this.fetchForYouMembership(data);
    } catch (err) {
      console.log(err);
    }
  };

  //--------------------------------------------Reload component----------------------------------------------//

  componentDidMount() {
    this.handleSubmit(this.state.defaultPageNo);
  }

  //-------------------------------------------End API-------------------------------------------------------\\

  render() {
    const { DataList, length, pageNo, togglingApprovalIds, forYouMap, togglingForYouIds } =
      this.state;
    let i = (pageNo - 1) * Constant.perPage;

    let bodyData = "";
    if (DataList.length > 0) {
      bodyData = DataList.map((el) => {
        i++;
        let status = "PENDING";
        let statusClass = "is-pending";

        if (el.status === 1) {
          status = "APPROVED";
          statusClass = "is-active";
        } else if (el.status === 2) {
          status = "REJECTED";
          statusClass = "is-inactive";
        }

        let contestType = "No";
        let btnStatus = false;

        if (el.contestId) {
          contestType = "Yes";
          btnStatus = true;
        }

        return (
          <tr key={el._id}>
            <td>{i}</td>
            <td className="namecol">{el.name}</td>
            <td className="namecol" onClick={() => this.openDescriptionPopup(el.description)} style={{ cursor: 'pointer' }} title="Click to view full description">
              <div 
                dangerouslySetInnerHTML={{ __html: el.description }} 
                style={{ 
                  maxHeight: '3em', 
                  maxWidth: '300px',
                  overflow: 'hidden', 
                  textOverflow: 'ellipsis', 
                  display: '-webkit-box', 
                  WebkitLineClamp: 2, 
                  WebkitBoxOrient: 'vertical',
                  wordBreak: 'break-word'
                }} 
              />
            </td>
            <td>
              <img
                src={el.thumbnail}
                alt="ind"
                style={{ width: 50, height: 50 }}
                key={el._id}
                resizemode="contain"
              />
            </td>
            <td className="namecol">
              {el.user && el.user.name ? (
                <a 
                  href={`https://www.storytent.in/userprofile/${el.userId}`} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ color: '#007bff', textDecoration: 'underline', cursor: 'pointer' }}
                >
                  {el.user.name}
                </a>
              ) : "N/A"}
            </td>
            <td className="namecol">{new Date(el.createdAt).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })}</td>
            <td className="namecol">{el._id}</td>
            <td>
              <button
                type="button"
                className={`contest-status-pill ${statusClass} content-library-status-pill`}
                onClick={() => this.toggleApprovalStatus(el._id, el.status)}
                disabled={
                  btnStatus || !!togglingApprovalIds[String(el._id)]
                }
                aria-busy={!!togglingApprovalIds[String(el._id)]}
                title={
                  togglingApprovalIds[String(el._id)]
                    ? "Updating…"
                    : el.status === 2
                    ? "Click to approve"
                    : el.status === 1
                    ? "Click to reject"
                    : "Click to approve (pending)"
                }
              >
                {status}
              </button>
            </td>
            <td>{contestType}</td>
            <td className="actions-col content-library-actions-col">
              <div className="content-library-actions-wrap">
                <button
                  className={`btn content-library-foryou-btn ${
                    forYouMap[String(el._id)] ? "btn-warning" : "btn-secondary"
                  }`}
                  onClick={() => this.toggleForYou(el)}
                  disabled={!!togglingForYouIds[String(el._id)]}
                  title={
                    forYouMap[String(el._id)]
                      ? "Remove from For You"
                      : "Add to For You"
                  }
                >
                  {togglingForYouIds[String(el._id)]
                    ? "Saving..."
                    : forYouMap[String(el._id)]
                    ? "Remove"
                    : "For You"}
                </button>
                <button
                  type="button"
                  className="contest-icon-btn danger"
                  onClick={() => {
                    if (window.confirm("Delete the poem?")) {
                      this.delete(el._id);
                    }
                  }}
                  title="Delete Poem"
                  aria-label="Delete poem"
                >
                  <FontAwesomeIcon icon={faTrashAlt} style={{ fontSize: "13px" }} />
                </button>
                <button
                  type="button"
                  className="contest-icon-btn"
                  onClick={() => {
                    this.update(el._id);
                  }}
                  title="Update Poem"
                  aria-label="Update poem"
                >
                  <FontAwesomeIcon icon={faEdit} style={{ fontSize: "13px" }} />
                </button>
              </div>
            </td>
          </tr>
        );
      });
    }

    let previous = 0;
    let next = 0;
    let customLength = 0;

    if (pageNo !== 0) {
      previous = pageNo - 1;
      next = pageNo + 1;
    }

    if (length !== 0) {
      customLength = length;
    }

    if (length < 2) {
      $(".pagination").hide();
    }

    $("#searchKey").on("change", () => {
      $("#selectValue").children(":selected").prop("selected", false);
    });

    $("#selectValue").on("change", () => {
      $("#searchKey").children(":selected").prop("selected", false);
    });

    $(".export-content-btn").on("click", async () => {
      try {
        let token = getAccessToken();
        var { data } = await Axios.post(
          Constant.apiBasePath + "poem/get-all",
          { exportData: 1 },
          { headers: { token: token } }
        );
        console.log(data);
        if (data.status === Constant.statusSuccess) {
          var csvString = data.data;
          var universalBOM = "\uFEFF";
          var a = window.document.createElement("a");
          a.setAttribute(
            "href",
            "data:text/csv; charset=utf-8," +
              encodeURIComponent(universalBOM + csvString)
          );
          a.setAttribute("download", "poems.csv");
          window.document.body.appendChild(a);
          a.click();
          window.location.reload();
        } else {
          alert(data.message);
          return false;
        }
      } catch (error) {
        console.log(error);
      }
    });


    return (
      <div className="content-page contest-submissions-page contest-management-page content-library-page poem-management-page event-consistent-page">
        <div className="content page-content-spaced">
          <div className="event-management-header">
            <div className="header-content">
              <div className="header-title">
                <h4 className="page-title-heading">Poem Management</h4>
                <p className="header-subtitle">
                  Manage poem content, approvals, and visibility.
                </p>
              </div>
              <div className="header-actions">
                <button className="btn btn-success export-content-btn">
                  Export Data
                </button>
                <Link to="/create-poem" className="btn btn-primary btn-add-event contest-add-match">
                  + Add New Poem
                </Link>
              </div>
            </div>
          </div>

          <div className="event-management-body">
            <div className="card contest-like-card">
              <div className="card-body">
                <div className="content-library-toolbar mb-3">
                  <div className="content-library-filter-group">
                    <select
                      id="selectValue"
                      onChange={() => this.handleSubmit(this.state.defaultPageNo)}
                      className="form-control filter-select"
                    >
                      <option value="all">Select one</option>
                      <option value="0">Pending</option>
                      <option value="1">Approved</option>
                      <option value="2">Rejected</option>
                    </select>
                  </div>
                  <div className="content-library-search-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by Name or Id"
                      value={this.state.searchValue}
                      onChange={this.handleSearchValueChange}
                    />
                  </div>
                  <p id="gen-message" className="message-feedback"></p>
                </div>

                <div className="table-wrapper contest-submissions-table-responsive contest-like-table-responsive">
                  <table id="complex-header-datatable" className="table event-table contest-submissions-table contest-like-table content-library-table">
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Thumbnail</th>
                        <th>Author</th>
                        <th>Created At</th>
                        <th>Post ID</th>
                        <th>Approved/Rejected</th>
                        <th className="namecol">Contest Type</th>
                        <th className="actions-col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {DataList.length > 0 ? (
                        bodyData
                      ) : (
                        <tr>
                          <td colSpan="9" className="table-loading-cell">
                            No poems found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="pagination-wrapper">
                  <div className="pagination">
                    {pageNo <= 1 ? (
                      <a className="default-previous">Previous</a>
                    ) : (
                      <a className="paginate-link" onClick={() => this.handleSubmit(previous)}>
                        Previous
                      </a>
                    )}
                    <a>{pageNo}</a>
                    {pageNo >= customLength ? (
                      <a className="default-next">Next</a>
                    ) : (
                      <a className="paginate-link active" onClick={() => this.handleSubmit(next)}>
                        Next
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.selectedDescription && (
          <div className="description-overlay" onClick={this.closeDescriptionPopup} style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyItems: 'center', justifyContent: 'center' }}>
            <div className="description-modal" onClick={e => e.stopPropagation()} style={{ background: 'white', padding: '20px', borderRadius: '8px', maxWidth: '600px', width: '90%', maxHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                <h4 style={{ margin: 0 }}>Description</h4>
                <button onClick={this.closeDescriptionPopup} style={{ border: 'none', background: 'transparent', fontSize: '24px', cursor: 'pointer', padding: '0 5px' }}>&times;</button>
              </div>
              <div style={{ marginBottom: '15px' }}>
                <button onClick={this.toggleHtml} className="btn btn-primary btn-sm">
                  {this.state.showHtml ? 'Show Raw Text' : 'Render HTML'}
                </button>
              </div>
              <div style={{ flex: 1, overflowY: 'auto', padding: '10px', border: '1px solid #ccc', borderRadius: '4px', wordBreak: 'break-word', whiteSpace: this.state.showHtml ? 'normal' : 'pre-wrap' }}>
                {this.state.showHtml ? (
                  <div dangerouslySetInnerHTML={{ __html: this.state.selectedDescription }} />
                ) : (
                  <div>{this.state.selectedDescription}</div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
export default DataManagement;
